module.exports = __webpack_public_path__ + "img/Überschwemmtes_Gebiet.be925ade.svg";